import { Link } from "react-router-dom";
import { AlertTriangle, AlertOctagon, Info } from "lucide-react";

const ICONS = { error: AlertOctagon, warning: AlertTriangle, info: Info };
const TONES = {
  error: "text-red-600 bg-red-50 border-red-200",
  warning: "text-amber-700 bg-amber-50 border-amber-200",
  info: "text-blue-700 bg-blue-50 border-blue-200",
};

export default function ManagementAttention({ signals, testId = "management-attention" }) {
  return (
    <div className="bg-white rounded-lg border border-slate-200 p-4" data-testid={testId}>
      <h3 className="text-sm font-semibold text-slate-900 mb-2">Management Attention</h3>
      {!signals?.length && (
        <p className="text-xs text-slate-400" data-testid={`${testId}-empty`}>No exceptions — all tracked signals are within configured targets.</p>
      )}
      <ul className="space-y-1.5">
        {(signals || []).map((s, i) => {
          const Icon = ICONS[s.severity] || Info;
          return (
            <li key={`${s.code}-${i}`} data-testid={`${testId}-signal-${s.code.toLowerCase()}`}>
              <Link to={s.link || "/"} className={`flex items-center gap-2 text-xs rounded-lg border px-2.5 py-1.5 ${TONES[s.severity] || TONES.info}`}>
                <Icon className="h-3.5 w-3.5 shrink-0" />
                <span>{s.message}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
